import { ArrowBigDownDash, ArrowBigUpDash, Equal } from 'lucide-react';

export const Percentage = ({
  value = 0,
  prepend,
  append,
}: {
  value: string | number;
  prepend?: string;
  append?: string;
}) => {
  const numberValue = Number(value);
  const formattedValue = Number(numberValue < 0 ? numberValue * -1 : numberValue).toFixed(
    numberValue % 1 === 0 ? 0 : 2
  );

  const ArrowIcon = numberValue > 0 ? ArrowBigUpDash : numberValue < 0 ? ArrowBigDownDash : Equal;
  const bgColor = numberValue > 0 ? 'bg-green-400' : numberValue < 0 ? 'bg-red-400' : 'bg-grey-700';
  const textColor =
    numberValue > 0 ? 'text-green-400' : numberValue < 0 ? 'text-red-400' : 'text-grey-700';

  return (
    <div className="flex items-center gap-1">
      <div className={`flex h-4 w-4 items-center justify-center rounded-full ${bgColor}`}>
        <ArrowIcon className={`h-3 w-3 rounded-full text-white ${bgColor}`} />
      </div>
      <span className={`text-xs font-normal ${textColor}`}>
        {prepend}
        {formattedValue}
        {append}
      </span>
    </div>
  );
};
